module.exports = __webpack_public_path__ + "static/media/avatar3.c1a8b069.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatars/avatar3.png
// module id = 37
// module chunks = 0